import * as React from 'react'
import Svg, { SvgProps, Defs, Path, LinearGradient, Stop, G, Mask, Use } from 'react-native-svg'
/* SVGR has dropped some elements not supported by react-native-svg: title */

const SvgComponent = (props: SvgProps) => (
  <Svg width={136} height={40} {...props}>
    <Defs>
      <Path
        d="m.537 24.779-.075-.072C.172 24.399 0 23.922 0 23.302v.146V1.327v.152C0 .808.2.303.536 0l12.389 12.39L.537 24.779M0 1.326"
        id="a"
      />
      <Path
        d="m4.13 8.408.094-.053 4.893-2.78c.466-.265.777-.587.932-.927-.155.34-.465.662-.932.927l-4.893 2.78-.094.053m.001-.146L0 4.131 4.131 0l4.986 2.833c.633.36.989.824 1.048 1.297v.002c-.059.473-.415.937-1.048 1.297L4.131 8.262"
        id="c"
      />
      <Path
        d="M12.389 12.86 0 .47C.235.258.537.146.883.146c.338 0 .719.108 1.122.336L16.52 8.729l-4.131 4.131m4.224-4.224L2.005.336C1.603.108 1.221 0 .883 0H.878h.006c.338 0 .719.107 1.121.336l14.608 8.3"
        id="e"
      />
      <Path id="g" d="M.453.526.547.473.453.526" />
      <Path d="M.694 1.551C.404 1.243.231.766.231.146V0c0 .62.172 1.097.461 1.405l.076.072-.076.074" id="i" />
      <Path id="k" d="M.464.537H.462L.537.463.463.537" />
      <Path
        d="M.093 4.223 0 4.13l4.986-2.833C5.619.937 5.975.473 6.034 0c0 .174-.039.347-.116.516-.155.34-.466.662-.932.927L.093 4.223"
        id="n"
      />
      <Path
        d="M6.034 4.223c-.059-.473-.415-.937-1.048-1.297L0 .093.093 0l4.893 2.781c.698.396 1.047.919 1.048 1.442"
        id="p"
      />
      <Path
        d="M0 1.625v-.153c0-.055.001-.109.004-.162v-.004l.001-.005V1.3C.034.767.2.351.462.073l.074.073C.2.449 0 .954 0 1.625"
        id="r"
      />
      <Path
        d="M16.594 8.729 2.079.482C1.676.254 1.295.146.957.146.611.146.309.258.074.47L0 .397a1.19 1.19 0 0 1 .072-.07L.074.324C.308.114.607.001.949 0h.008c.338 0 .72.108 1.122.336l14.608 8.3-.093.093"
        id="t"
      />
      <LinearGradient x1="1485.45%" y1="-963.09%" x2="-790.38%" y2="1312.74%" id="l">
        <Stop stopColor="#DF333B" offset="0%" />
        <Stop stopColor="#AB0F55" offset="100%" />
      </LinearGradient>
      <LinearGradient x1="61.034%" y1="4.948%" x2="26.503%" y2="71.907%" id="v">
        <Stop stopColor="#00A0FF" offset="0%" />
        <Stop stopColor="#00A1FF" offset="1%" />
        <Stop stopColor="#00BEFF" offset="26%" />
        <Stop stopColor="#00D2FF" offset="51%" />
        <Stop stopColor="#00DFFF" offset="76%" />
        <Stop stopColor="#00E3FF" offset="100%" />
      </LinearGradient>
      <LinearGradient x1="107.685%" y1="50%" x2="-130.64%" y2="50%" id="w">
        <Stop stopColor="#FFE000" offset="0%" />
        <Stop stopColor="#FFBD00" offset="41%" />
        <Stop stopColor="orange" offset="78%" />
        <Stop stopColor="#FF9C00" offset="100%" />
      </LinearGradient>
      <LinearGradient x1="86.219%" y1="30.911%" x2="-50.15%" y2="135.988%" id="x">
        <Stop stopColor="#FF3A44" offset="0%" />
        <Stop stopColor="#C31162" offset="100%" />
      </LinearGradient>
      <LinearGradient x1="-18.754%" y1="-11.832%" x2="42.121%" y2="35.095%" id="y">
        <Stop stopColor="#32A071" offset="0%" />
        <Stop stopColor="#2DA771" offset="7%" />
        <Stop stopColor="#15CF74" offset="48%" />
        <Stop stopColor="#06E775" offset="80%" />
        <Stop stopColor="#00F076" offset="100%" />
      </LinearGradient>
    </Defs>
    <G fill="none" fillRule="evenodd">
      <Path
        d="M130.287 40h-125c-2.75 0-5-2.25-5-5V5c0-2.75 2.25-5 5-5h125c2.75 0 5 2.25 5 5v30c0 2.75-2.25 5-5 5"
        fill="#000"
      />
      <Path
        d="M130.287 0h-125c-2.75 0-5 2.25-5 5v30c0 2.75 2.25 5 5 5h125c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5m0 .8c2.316 0 4.2 1.884 4.2 4.2v30c0 2.316-1.884 4.2-4.2 4.2h-125a4.205 4.205 0 0 1-4.2-4.2V5c0-2.316 1.884-4.2 4.2-4.2h125"
        fill="#A6A6A6"
      />
      <Path
        d="M107.223 30h1.866V17.499h-1.866V30Zm16.807-7.998-2.14 5.42h-.063l-2.22-5.42h-2.01l3.329 7.575-1.898 4.214h1.947l5.13-11.789h-2.075Zm-10.582 6.578c-.612 0-1.464-.305-1.464-1.061 0-.965 1.062-1.335 1.978-1.335.82 0 1.206.177 1.705.418a2.262 2.262 0 0 1-2.22 1.978Zm.225-6.851c-1.351 0-2.75.595-3.33 1.914l1.657.691c.354-.691 1.013-.917 1.705-.917.965 0 1.946.579 1.962 1.609v.128c-.338-.193-1.061-.482-1.946-.482-1.785 0-3.603.981-3.603 2.814 0 1.673 1.464 2.751 3.104 2.751 1.255 0 1.946-.563 2.38-1.223h.065v.965h1.8v-4.792c0-2.22-1.655-3.458-3.794-3.458Zm-11.532 1.795h-2.654v-4.285h2.654c1.395 0 2.187 1.155 2.187 2.142 0 .969-.792 2.143-2.187 2.143Zm-.048-6.025h-4.471V30h1.865v-4.736h2.606c2.068 0 4.1-1.498 4.1-3.883s-2.032-3.882-4.1-3.882ZM77.712 28.582c-1.29 0-2.368-1.079-2.368-2.561 0-1.498 1.079-2.594 2.368-2.594 1.273 0 2.27 1.096 2.27 2.594 0 1.482-.997 2.561-2.27 2.561Zm2.142-5.88h-.064c-.42-.499-1.224-.95-2.24-.95-2.126 0-4.075 1.868-4.075 4.269 0 2.384 1.949 4.237 4.076 4.237 1.015 0 1.82-.451 2.239-.967h.064v.612c0 1.628-.87 2.498-2.271 2.498-1.144 0-1.853-.822-2.143-1.515l-1.627.677c.467 1.128 1.708 2.513 3.77 2.513 2.19 0 4.044-1.289 4.044-4.43v-7.637h-1.773v.693ZM82.916 30h1.869V17.498h-1.87V30Zm4.623-4.124c-.048-1.643 1.273-2.481 2.223-2.481.742 0 1.37.37 1.579.902l-3.802 1.579Zm5.8-1.418c-.354-.95-1.434-2.706-3.641-2.706-2.191 0-4.011 1.723-4.011 4.253 0 2.384 1.804 4.253 4.22 4.253 1.95 0 3.078-1.192 3.545-1.885l-1.45-.967c-.483.709-1.144 1.176-2.095 1.176-.95 0-1.627-.435-2.062-1.288l5.687-2.352-.193-.484ZM48.03 23.057v1.804h4.317c-.13 1.015-.467 1.756-.982 2.272-.63.628-1.612 1.32-3.335 1.32-2.658 0-4.737-2.142-4.737-4.8 0-2.659 2.079-4.801 4.737-4.801 1.434 0 2.48.564 3.254 1.289l1.273-1.273c-1.08-1.031-2.513-1.821-4.527-1.821-3.641 0-6.702 2.965-6.702 6.606s3.06 6.605 6.702 6.605c1.965 0 3.447-.644 4.607-1.853 1.192-1.192 1.563-2.867 1.563-4.221 0-.419-.032-.805-.097-1.127H48.03Zm11.079 5.525c-1.29 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.4-2.578 1.289 0 2.4 1.047 2.4 2.578 0 1.514-1.111 2.577-2.4 2.577Zm0-6.83c-2.353 0-4.27 1.788-4.27 4.253 0 2.448 1.917 4.253 4.27 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.27-4.253Zm9.313 6.83c-1.29 0-2.401-1.063-2.401-2.577 0-1.531 1.112-2.578 2.4-2.578 1.29 0 2.4 1.047 2.4 2.578 0 1.514-1.11 2.577-2.4 2.577Zm0-6.83c-2.352 0-4.27 1.788-4.27 4.253 0 2.448 1.918 4.253 4.27 4.253 2.352 0 4.269-1.805 4.269-4.253 0-2.465-1.917-4.253-4.27-4.253Z"
        fill="#FFF"
      />
      <G transform="translate(10.26 7.611)">
        <Mask id="b" fill="#fff">
          <Use xlinkHref="#a" />
        </Mask>
        <Path
          d="m.537 24.779-.075-.072C.172 24.399 0 23.922 0 23.302v.146V1.327v.152C0 .808.2.303.536 0l12.389 12.39L.537 24.779M0 1.326"
          mask="url(#b)"
        />
      </G>
      <G transform="translate(23.185 15.87)">
        <Mask id="d" fill="#fff">
          <Use xlinkHref="#c" />
        </Mask>
        <Path
          d="m4.13 8.408.094-.053 4.893-2.78c.466-.265.777-.587.932-.927-.155.34-.465.662-.932.927l-4.893 2.78-.094.053m.001-.146L0 4.131 4.131 0l4.986 2.833c.633.36.989.824 1.048 1.297v.002c-.059.473-.415.937-1.048 1.297L4.131 8.262"
          mask="url(#d)"
        />
      </G>
      <G transform="translate(10.796 7.141)">
        <Mask id="f" fill="#fff">
          <Use xlinkHref="#e" />
        </Mask>
        <Path
          d="M12.389 12.86 0 .47C.235.258.537.146.883.146c.338 0 .719.108 1.122.336L16.52 8.729l-4.131 4.131m4.224-4.224L2.005.336C1.603.108 1.221 0 .883 0H.878h.006c.338 0 .719.107 1.121.336l14.608 8.3"
          mask="url(#f)"
        />
      </G>
      <Path
        d="M11.772 32.859c.315-.018.663-.126 1.029-.334l14.514-8.247L12.8 32.525c-.366.208-.714.316-1.03.334"
        fill="#000"
      />
      <G transform="translate(26.862 23.752)">
        <Mask id="h" fill="#fff">
          <Use xlinkHref="#g" />
        </Mask>
        <Path mask="url(#h)" d="M.453.526.547.473.453.526" />
      </G>
      <Path d="M10.722 32.464c-.29-.307-.462-.785-.462-1.404v-.001c0 .62.172 1.097.462 1.405" fill="#000" />
      <G transform="translate(10.028 30.913)">
        <Mask id="j" fill="#fff">
          <Use xlinkHref="#i" />
        </Mask>
        <Path d="M.694 1.551C.404 1.243.231.766.231.146V0c0 .62.172 1.097.461 1.405l.076.072-.076.074" mask="url(#j)" />
      </G>
      <G transform="translate(10.26 31.927)">
        <Mask id="m" fill="#fff">
          <Use xlinkHref="#k" />
        </Mask>
        <Path fill="url(#l)" mask="url(#m)" d="M.464.537H.462L.537.463.463.537" />
      </G>
      <Path d="M33.234 20.518c.077-.169.116-.342.116-.516v-.001c0 .174-.04.348-.116.517" fill="#000" />
      <G transform="translate(27.316 20.002)">
        <Mask id="o" fill="#fff">
          <Use xlinkHref="#n" />
        </Mask>
        <Path
          d="M.093 4.223 0 4.13l4.986-2.833C5.619.937 5.975.473 6.034 0c0 .174-.039.347-.116.516-.155.34-.466.662-.932.927L.093 4.223"
          mask="url(#o)"
        />
      </G>
      <Path
        d="M33.35 20.001V20c-.001-.523-.35-1.046-1.048-1.442l-4.893-2.781 4.893 2.78c.699.397 1.049.921 1.048 1.444"
        fill="#404040"
      />
      <G transform="translate(27.316 15.777)">
        <Mask id="q" fill="#fff">
          <Use xlinkHref="#p" />
        </Mask>
        <Path
          d="M6.034 4.223c-.059-.473-.415-.937-1.048-1.297L0 .093.093 0l4.893 2.781c.698.396 1.047.919 1.048 1.442"
          mask="url(#q)"
        />
      </G>
      <Path
        d="M10.265 8.765c.057-1.027.616-1.621 1.406-1.624a1.286 1.286 0 0 0-.875.324l-.002.003a1.19 1.19 0 0 0-.072.07c-.262.278-.428.694-.457 1.227"
        fill="#404040"
      />
      <G transform="translate(10.26 7.465)">
        <Mask id="s" fill="#fff">
          <Use xlinkHref="#r" />
        </Mask>
        <Path
          d="M0 1.625v-.153c0-.055.001-.109.004-.162v-.004l.001-.005V1.3C.034.767.2.351.462.073l.074.073C.2.449 0 .954 0 1.625"
          mask="url(#s)"
        />
      </G>
      <Path d="M11.67 7.141h.004-.003" fill="#404040" />
      <G transform="translate(10.722 7.141)">
        <Mask id="u" fill="#fff">
          <Use xlinkHref="#t" />
        </Mask>
        <Path
          d="M16.594 8.729 2.079.482C1.676.254 1.295.146.957.146.611.146.309.258.074.47L0 .397a1.19 1.19 0 0 1 .072-.07L.074.324C.308.114.607.001.949 0h.008c.338 0 .72.108 1.122.336l14.608 8.3-.093.093"
          mask="url(#u)"
        />
      </G>
      <Path
        d="M43.298 13.134c-.436 0-.807-.121-1.115-.364-.307-.244-.525-.585-.653-1.027l.704-.293c.179.631.545.946 1.097.946.358 0 .633-.115.826-.347.192-.232.289-.546.289-.943V7h.77v4.089c0 .654-.18 1.158-.54 1.513-.36.355-.82.532-1.378.532"
        fill="#FFF"
      />
      <Path
        d="M43.298 13.134v-.1c-.418-.001-.763-.115-1.053-.343-.288-.229-.496-.55-.62-.976l-.095.028.038.093.704-.294-.038-.092-.096.027c.178.657.598 1.025 1.193 1.02.378.001.69-.127.903-.384.21-.254.312-.595.312-1.007V7.1h.57v3.989c0 .637-.173 1.109-.51 1.442-.342.336-.77.502-1.308.503v.2c.579.001 1.07-.187 1.448-.561.384-.377.572-.912.57-1.584V6.9h-.97v4.206c-.001.381-.092.67-.266.879-.173.207-.412.31-.75.312-.508-.006-.821-.269-1-.874l-.031-.109-.808.337-.082.034.025.086c.132.457.362.82.687 1.077.326.258.723.386 1.177.386v-.1M49.994 7.737H47.26V9.64h2.464v.72H47.26v1.903h2.733V13H46.49V7h3.503v.737"
        fill="#FFF"
      />
      <Path
        fill="#FFF"
        d="M49.994 7.737v-.1H47.16V9.74h2.464v.52H47.16v2.103h2.732v.537H46.59V7.1h3.302v.637h.1v-.1.1h.1V6.9h-3.702v6.2h3.703v-.937H47.36V10.46h2.464v-.92H47.36V7.837h2.733v-.1h-.1M53.245 13h-.772V7.737h-1.676V7h4.123v.737h-1.675V13"
      />
      <Path
        fill="#FFF"
        d="M53.245 13v-.1h-.672V7.637h-1.676V7.1h3.923v.537h-1.676V13h.1v-.1.1h.1V7.837h1.676V6.9h-4.323v.937h1.676V13.1h.97V13h-.098M55.558 13v-.805l3.192-4.458h-3.058V7h3.955v.805l-3.192 4.458h3.226V13h-4.123"
      />
      <Path
        fill="#FFF"
        d="M55.558 13h.1v-.773l3.287-4.59h-3.153V7.1h3.755v.673l-3.287 4.59h3.32v.537h-4.022v.1h.1-.1v.1h4.223v-.937h-3.132l3.098-4.326V6.9h-4.155v.937h2.964l-3.098 4.326v.937h.1V13M62.83 13h-.77V7.737h-1.676V7h4.123v.737H62.83V13"
      />
      <Path
        fill="#FFF"
        d="M62.83 13v-.1h-.67V7.637h-1.676V7.1h3.923v.537H62.73V13h.1v-.1.1h.1V7.837h1.676V6.9h-4.323v.937h1.676V13.1h.97V13h-.1M68.262 12.263h1.55a.92.92 0 0 0 .72-.311.993.993 0 0 0 .277-.679.965.965 0 0 0-.285-.674c-.19-.203-.438-.306-.746-.306h-1.516v1.97Zm0-2.691h1.399c.29 0 .524-.095.7-.289a.917.917 0 0 0 .264-.632.92.92 0 0 0-.256-.629.863.863 0 0 0-.674-.285h-1.433v1.835ZM67.492 13V7h2.169c.47 0 .876.155 1.22.465.343.31.515.7.515 1.169 0 .285-.074.536-.222.754a1.4 1.4 0 0 1-.591.495v.033c.296.101.539.274.729.52.19.246.286.531.286.855 0 .491-.181.899-.541 1.223a1.851 1.851 0 0 1-1.28.486h-2.285Z"
      />
      <Path
        d="M68.262 12.263v.1h1.55c.319.001.594-.116.796-.344.198-.22.302-.474.3-.746a1.063 1.063 0 0 0-.311-.742 1.074 1.074 0 0 0-.82-.338h-1.615v2.17h.1v-.1h.1v-1.87h1.416c.286.001.502.092.673.274.177.191.258.387.259.606a.895.895 0 0 1-.251.612l-.001.001a.82.82 0 0 1-.646.277h-1.55v.1h.1-.1Zm0-2.691v.1h1.399a.998.998 0 0 0 .774-.321c.189-.206.29-.445.29-.7a1.02 1.02 0 0 0-.282-.695.963.963 0 0 0-.748-.319h-1.533v2.035h.1v-.1h.1V7.837h1.333c.257.002.447.084.599.252.158.176.23.358.23.562a.818.818 0 0 1-.237.565c-.157.172-.356.255-.626.256h-1.4v.1h.1-.1ZM67.492 13h.1V7.1h2.069c.448.001.825.145 1.153.439.324.295.48.651.482 1.095a1.2 1.2 0 0 1-.205.698 1.3 1.3 0 0 1-.55.46l-.058.026v.17l.068.023c.278.095.503.255.682.486v-.001c.176.23.264.49.265.795a1.475 1.475 0 0 1-.508 1.148c-.344.309-.742.46-1.212.461h-2.286v.1h.1-.1v.1h2.286c.514.001.969-.172 1.345-.512.38-.34.576-.781.574-1.297a1.463 1.463 0 0 0-.305-.916l-.001-.001a1.625 1.625 0 0 0-.776-.553l-.032.095h.1v-.033h-.1l.04.091c.263-.119.476-.296.634-.53h-.001c.16-.234.24-.508.24-.81a1.608 1.608 0 0 0-.548-1.243l-.003-.002.003.001a1.864 1.864 0 0 0-1.287-.49h-2.27v6.2h.1V13ZM76.139 7.737h-2.733V9.64h2.464v.72h-2.464v1.903h2.733V13h-3.503V7h3.503v.737"
        fill="#FFF"
      />
      <Path
        fill="#FFF"
        d="M76.139 7.737v-.1h-2.833V9.74h2.464v.52h-2.464v2.103h2.733v.537h-3.303V7.1h3.303v.637h.1v-.1.1h.1V6.9h-3.703v6.2h3.703v-.937h-2.733V10.46h2.464v-.92h-2.464V7.837h2.733v-.1h-.1M77.346 13h.77V7h-.77z"
      />
      <Path fill="#FFF" d="M77.346 13h.1V7.1h.57v5.8h-.67v.1h.1-.1v.1h.87V6.9h-.97v6.2h.1V13" />
      <G fillRule="nonzero">
        <Path
          d="M1.44.54a2 2 0 0 0-.46 1.4v22.12a2 2 0 0 0 .46 1.4l.07.07L13.9 13.15v-.29L1.51.47l-.07.07Z"
          fill="url(#v)"
          transform="translate(9.287 7)"
        />
        <Path
          d="m18 17.28-4.1-4.13v-.29L18 8.72l.09.05L23 11.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78-.11.05Z"
          fill="url(#w)"
          transform="translate(9.287 7)"
        />
        <Path
          d="M18.12 17.22 13.9 13 1.44 25.46a1.63 1.63 0 0 0 2.08.06l14.61-8.3"
          fill="url(#x)"
          transform="translate(9.287 7)"
        />
        <Path
          d="M18.12 8.78 3.51.48a1.63 1.63 0 0 0-2.08.06L13.9 13l4.22-4.22Z"
          fill="url(#y)"
          transform="translate(9.287 7)"
        />
        <Path
          d="m27.287 24.13-14.49 8.25a1.67 1.67 0 0 1-2 0l-.07.07.07.07a1.66 1.66 0 0 0 2 0l14.61-8.3-.12-.09Z"
          fill="#000"
          opacity={0.2}
        />
        <Path
          d="M10.727 32.32a2 2 0 0 1-.46-1.4v.15a2 2 0 0 0 .46 1.4l.07-.07-.07-.08Zm21.56-11.02-5 2.83.09.09 4.91-2.78a1.75 1.75 0 0 0 1-1.44 1.86 1.86 0 0 1-1 1.3Z"
          fill="#000"
          opacity={0.12}
        />
        <Path
          d="m12.797 7.62 19.49 11.08a1.86 1.86 0 0 1 1 1.3 1.75 1.75 0 0 0-1-1.44L12.797 7.48c-1.4-.79-2.54-.13-2.54 1.47v.15c.03-1.61 1.15-2.27 2.54-1.48Z"
          fill="#FFF"
          opacity={0.25}
        />
      </G>
    </G>
  </Svg>
)

export default SvgComponent
